const companyRoutes = [
    // HOME
    {
        path: '/company/home',
        name: 'company.home',
        component: () => import('@/views/company/Home'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
            rightPanel: 'CompanyHomePanel',
        }
    },

    // STUDENTS
    {
        path: '/company/students/:uid',
        name: 'company.students.profile',
        component: () => import('@/views/coach/StudentProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // COACHES
    {
        path: '/company/coaches/:uid',
        name: 'company.coaches.profile',
        component: () => import('@/views/company/CoachProfile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ADMIN GYM
    {
        path: '/company/admin',
        name: 'company.admin',
        component: () => import('@/views/company/Admin'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
            rightPanel: 'CompanyAdminPanel',
        },
    },

    // BUSINESS
    {
        path: '/company/business',
        name: 'company.business',
        component: () => import('@/views/company/Business'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },

    // LIBRARY
    {
        path: '/company/library',
        name: 'company.library',
        component: () => import('@/views/company/Library'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ZAPPING
    {
        path: '/company/zapping',
        name: 'company.zapping',
        component: () => import('@/views/company/Zapping'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // ROUTINES
    {
        path: '/company/routines/:uid',
        name: 'company.routines.detail',
        component: () => import('@/views/coach/RoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/:uid/edit',
        name: 'company.routines.edit',
        component: () => import('@/views/coach/EditRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/:uid/edit/assigned',
        name: 'company.routines.edit.assigned',
        component: () => import('@/views/coach/EditAssignedRoutine'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // PROGRAMS
    {
        path: '/company/routines/programs/:uid',
        name: 'company.routines.program.detail',
        component: () => import('@/views/coach/ProgramDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },
    {
        path: '/company/routines/programs/:uid/routine/:id',
        name: 'company.routines.program.detail.routine',
        component: () => import('@/views/coach/ProgramRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // CALENDAR
    {
        path: '/company/calendar',
        name: 'company.calendar',
        component: () => import('@/views/company/Calendar'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },
    {
        path: '/company/calendar/:uid',
        name: 'company.calendar.assignedRoutine',
        component: () => import('@/views/coach/AssignedRoutineDetail'),
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // STATISTICS
    {
        path: '/company/statistics',
        name: 'company.statistics',
        component: () => import('@/views/company/Statistics'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        }
    },

    // EVALUATIONS
    {
        path: '/company/evaluations',
        name: 'company.evaluations',
        component: () => import('@/views/company/Evaluations'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },

    {
        path: '/company/evaluations/statistics/:type/:id',
        name: 'company.evaluations.statistics',
        component: () => import('@/views/coach/EvaluationsStatistics'),
        meta: {
            drawer: true,
            toolbar: true,
        },
    },

    // PROFILE
    {
        path: '/company/profile',
        name: 'company.profile',
        component: () => import('@/views/company/Profile'),
        meta: {
            drawer: true,
            toolbar: true,
            footer: true,
        },
    },
    {
        path: '/company/payment-method',
        name: 'company.payment.edit',
        component: () => import('@/views/coach/PaymentMethod'),
        props: true,
        meta: {
            drawer: true,
            toolbar: true,
        }
    },

    // PAYMENT
    {
        path: '/company/select-plan',
        name: 'company.select-plan',
        component: () => import('@/views/coach/SelectPlan'),
    },
    {
        path: '/company/credit-card',
        name: 'company.credit-card',
        component: () => import('@/views/coach/CreditCard'),
    },
]

export default companyRoutes;